import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { bannerTheme } from "./bannerTheme";
export const BannerActionSeparatorStyled = styled("div")`
    width: 2px;
    height: ${sizes.large}px;
    margin: 0 ${sizes.xSmall}px;
    background-color: ${_ref => {
  let {
    bannerType,
    themeMode
  } = _ref;
  return bannerTheme.separatorColor[bannerType](themeMode);
}};
    display: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return bannerTheme.separatorDisplay(themeMode);
}};
`;
//# sourceMappingURL=BannerActionSeparatorStyled.js.map